import React, { useState, useEffect, useRef } from 'react';
import { Props } from './EventsAndProjectsSelect.utils';
import EventsAndProjectsSelectComponent from './EventsAndProjectsSelect.component';
import { View, TouchableHighlight, StyleSheet, Platform, Modal, TouchableWithoutFeedback } from 'react-native';
import ImageIcon from '../../Icon/ImageIcon.component';
import I18n from '../../i18n/I18n.component';
import useDevicePlatform, {
	DeviceType,
} from '../../../../hooks/useDevicePlatform.hook';
import { modalService } from '../../../../services/modal.service';
import getShadowStyle from '../../../../config/shadow';
import { ScrollView } from 'react-native-gesture-handler';
import Typography from '../../Typography/Typography.component';
import { i18nService } from '../../../../services/i18n.service';
import colors from '../../../../config/colors';

const EventsAndProjectsSelectContainer = ({
	placeHolder,
	isProject,
	onSubmit,
	onOpen,
	disabled,
	options,
	defaultOption,
	canReportFullDay,
	currentRunnigWorkLog,
}: Props) => {
	const isAlreadyOpened = useRef(false);
	const [isOpen, setIsOpen] = useState(false);
	const containerRef = useRef<View>(null);
	const [dropdownLayout, setDropdownLayout] = useState({ top: 0, left: 0, width: 0 });

	const closeDropdown = () => {
		onOpen(false);
		setIsOpen(false);
	};

	const handleContainerLayout = () => {
		containerRef.current?.measure((_x, _y, width, height, pageX, pageY) => {
			setDropdownLayout({ top: pageY + height, left: pageX, width });
		});
	};
	const showOptions = async () => {
		isAlreadyOpened.current = true;
		try {
			isAlreadyOpened.current = true;
			await modalService.openModal(
				null,
				{
					onCancel: (callback: Function) => {
						onOpen?.(!isOpen);
						setIsOpen?.(false);
						callback();
					},
					onSubmit: async (
						callback: Function,
						selectedOption: any,
						isEventSelect: boolean,
						isFullDaySelected: boolean,
					) => {
						try {
							onOpen?.(!isOpen);
							setIsOpen(false);
							onSubmit(
								selectedOption,
								isEventSelect,
								isFullDaySelected,
							);
							callback();
						} catch (error) {
							console.log(error);
						}
					},
				},

				(props: any) => (
					<EventsAndProjectsSelectComponent
						{...props}
						currentRunnigWorkLog={currentRunnigWorkLog}
						canReportFullDay={canReportFullDay}
						defaultOption={defaultOption}
						options={options}
						isEventSelect={!isProject}
						isModal={isMobile}
						closed={() => {
							isAlreadyOpened.current = false;
							onOpen?.(!isOpen);
							setIsOpen(false);
						}}
					/>
				),
			);
		} catch (e) {
			console.log(e);
		}
	};
	const platform = useDevicePlatform();
	const isMobile = platform !== DeviceType.WEB;
	const style = {
		flex: 1,
		height: 32,
		borderRadius: 8,
		paddingHorizontal: 16,
		paddingVertical: 6,
		justifyContent: 'center',
		backgroundColor: '#fff',
		borderWidth: 1,
		borderColor: colors.clockGreyText,
		
	};

	if (isMobile && isOpen && !isAlreadyOpened.current) showOptions();

	return (
		<View
			ref={containerRef}
			onLayout={handleContainerLayout}
			style={{
				position: 'relative',
				flex: 1,
				height: 32,
				zIndex: 1,
			}}
		>
			<TouchableHighlight
				style={style}
				underlayColor='transparent'
				onPress={() => {
					if (!disabled) {
						onOpen(!isOpen);
						setIsOpen(prev => setIsOpen(!prev));
					}
				}}
			>
				<View style={styles.selectInnerLayout}>
					<View style={{ width: '85%', flexDirection: 'row-reverse' }}>
						<ImageIcon 
							name={'calendar_checked'}
							width={15}
							height={15}
							style={{ marginLeft: 10, marginTop: 1 }}
						></ImageIcon>
						<Typography
							size={15}
							weight='normal'
							color='clockRecordBlue'
							numberOfLines={1}
						>
							{i18nService.translate(placeHolder)}
						</Typography>
					</View>
					<View style={{ width: '15%', flexDirection: 'row' }}>
						<ImageIcon
							name={'greyChevronDown'}
							width={14}
							height={14}
							style={{ alignSelf: 'center' }}
						></ImageIcon>
					</View>
				</View>
			</TouchableHighlight>
			{isOpen && !isMobile && (
				<Modal
					transparent
					visible
					animationType='none'
					onRequestClose={closeDropdown}
				>
					{/* allows closing the dropdown when clicking outside of it */}
					<TouchableWithoutFeedback onPress={closeDropdown}>
						<View style={StyleSheet.absoluteFill} />
					</TouchableWithoutFeedback>
					
					<View
						style={{ position: 'absolute', top: dropdownLayout.top, left: dropdownLayout.left, width: dropdownLayout.width }}
						onStartShouldSetResponder={() => true}
					>
						<EventsAndProjectsSelectComponent
							canReportFullDay={canReportFullDay}
							onCancel={closeDropdown}
							onSubmit={(
								selectedOption,
								isEventSelect,
								isFullDaySelected,
							) => {
								closeDropdown();
								onSubmit(
									selectedOption,
									isEventSelect,
									isFullDaySelected,
								);
							}}
							defaultOption={defaultOption}
							options={options}
							isEventSelect={!isProject}
							isModal={isMobile}
							currentRunnigWorkLog={currentRunnigWorkLog}
						/>
					</View>
				</Modal>
			)}
		</View>
	);
};
const styles = StyleSheet.create({
	select: {
		flex: 1,
		marginHorizontal: 10,
		height: 32,
		borderRadius: 45,
		justifyContent: 'center',
		backgroundColor: '#fff',
		borderWidth: 1,
	},

	selectInnerLayout: {
		flexDirection: 'row-reverse',
		justifyContent: 'space-between',
	},
});
export default EventsAndProjectsSelectContainer;
